import React from 'react';
import { cnTumbler } from '../Tumbler';
import './Tumbler-Button.css';
export var TumblerButton = function (_a) {
    var checked = _a.checked, children = _a.children, innerRef = _a.innerRef, labelledBy = _a.labelledBy, onBlur = _a.onBlur, onClick = _a.onClick, onFocus = _a.onFocus, onKeyDown = _a.onKeyDown, tabIndex = _a.tabIndex, required = _a.required;
    return (React.createElement("button", { "aria-required": required, "aria-labelledby": labelledBy, "aria-pressed": checked, className: cnTumbler('Button'), onBlur: onBlur, onClick: onClick, onFocus: onFocus, onKeyDown: onKeyDown, ref: innerRef, tabIndex: tabIndex, type: "button" }, children));
};
